import React, { useState } from "react";
import { Link } from "@reach/router";
import styles from "./MammalChampion.module.scss";
import JoinComponent from "./JoinComponent";
import Username from "./Username";

function LiverBird(props) {
  const [liverNo, setLiverNo] = React.useState(0);

  if (liverNo === 0) {
    return (
      <div className={styles.bkg}>
        <p>
          Hello I’m Liver Bird I sit up here watching you humans go around the
          city like you own the place and I tell you what, you need to start
          thinking about the non human scousers because you are being pure sly
          to them.
        </p>

        <p>
          Some of the humans at FACT in Liverpool are writing a new
          environmental policy, a bit of writing that decides what they will and
          won’t do to make FACT more friendly to non-humans and the environment.
        </p>
        <p>
          They have agreed to listen to non-human drama at a Town Hall meeting
          and say they are open to suggestions for how to make things better for
          all of them. So you better come thru!
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(1);
            }}
          >
            Enter the tutorial with some FAQ.
          </button>
        </p>
        <p>
          Or if you just want to play pick a folk and start writing reports you
          LAZY ASS
        </p>
      </div>
    );
  }
  if (liverNo === 1) {
    return (
      <div className={styles.bkg}>
        <p>I'll break it down to you ye?</p>

        <p>
          These are
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(2);
            }}
          >
            the folk
          </button>{" "}
          they’re all different, but kinda cool.
        </p>

        <p>
          There’s a{" "}
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(3);
            }}
          >
            tournament
          </button>{" "}
          going on, all the folk are competing to see who can influence the
          humans the most between 11th January and the 1st of February 2021.
        </p>

        <p>
          I don't have much time I'm busy and all that, so pick what you want me
          to help you with and let's get playing. That's the point of it all
          innit:
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(4);
            }}
          >
            Ok where do I go now?
          </button>
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(5);
            }}
          >
            I have no clue how you play m8
          </button>
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(6);
            }}
          >
            Incident Reports? What are you going on about?
          </button>
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(7);
            }}
          >
            I'm stuck I don't know what to write
          </button>
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(8);
            }}
          >
            How do I win?
          </button>
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(10);
            }}
          >
            I cannot find my incident report!
          </button>
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(11);
            }}
          >
            I cannot upload pics to my report...
          </button>
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(12);
            }}
          >
            When do I get points?
          </button>
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(16);
            }}
          >
            How do I make a BOSS Incident Report?
          </button>
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(13);
            }}
          >
            What happens at the Town Hall?
          </button>
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(14);
            }}
          >
            What if someone says something rude or hateful?
          </button>
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(15);
            }}
          >
            My name is Karen and I want to speak to your manager
          </button>
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(17);
            }}
          >
            I'm still very confused
          </button>
        </p>
      </div>
    );
  }

  if (liverNo === 2) {
    return (
      <div className={styles.bkg}>
        <p>
          You need to imagine you are a nonhuman person living, being in or
          visiting FACT, and all that.
        </p>{" "}
        <p>
          For example you might be a wood pigeon who found some shelter in the
          balcony after a long journey, or an ant trapped inside a vent in
          Gallery one, or some microbes living inside the ground floor toilets
          who are being attacked by some nasty chemicals.
        </p>
        <p>
          {" "}
          You earn points by pretending you're one of them telling us about your
          latest drama.
        </p>{" "}
        <p>To play, choose which Folk you want to join!</p>
        <p>
          Or for more answers,
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(1);
            }}
          >
            Go back!
          </button>
        </p>
      </div>
    );
  }
  if (liverNo === 3) {
    return (
      <div className={styles.bkg}>
        <p>
          This game you're looking at is part of a Tournament between all the
          non humans of Liverpool, to see who can influence the humans of FACT
          the most. We'll have to see which Folk collects the most points
          playing this game and from their champions performance at the live
          Town Hall event. Do you want to know more about the{" "}
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(13);
            }}
          >
            Town Hall
          </button>
          , find out who the{" "}
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(2);
            }}
          >
            non human folk
          </button>{" "}
          are, or do you want to know{" "}
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(8);
            }}
          >
            how to win?
          </button>
        </p>
        <p>
          Or for more answers,
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(1);
            }}
          >
            go back!
          </button>
        </p>
      </div>
    );
  }
  if (liverNo === 4) {
    return (
      <div className={styles.bkg}>
        <p>Plenty to do!</p>
        <p>
          You can talk to the champions of all the different nonhuman folks of
          Liverpool. They will try to convince you to join them, choose your
          folk!
        </p>
        <p>
          Then you will see a map of Liverpool with markers on it. You can see:
        </p>
        <p>Incident Report markers that you can read.</p>
        <p>The current score for the folks.</p>
        <p>Non human characters that you can talk to .</p>
        <p>
          Once you have chose your Folk you should be loyal, stick with them
          through the entire tournament!
        </p>
        <p>Get inspired and get writing. Good lad.</p>
        <p>
          Or for more answers,
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(1);
            }}
          >
            go back!
          </button>
        </p>
      </div>
    );
  }
  if (liverNo === 5) {
    return (
      <div className={styles.bkg}>
        <p>
          Just write as if you were a non-human telling us your problems. Spill
          the T. Tell us about your drama! Leave an Incident Report on the map
          telling us every single detail!
        </p>
        <p>
          Is that horrible divvy of a pigeon complaining about drunks outside
          the Lobster Pot at three in the afternoon on a Saturday?
        </p>
        <p>
          Or that annoying fish who is very concerned about industrial chemical
          waste being poured into the Mersey?
        </p>
        <p>
          If your T is good we'll give you a good score. The more convincing
          your complaint, the more points you can win for your Folk. All the
          Incident Reports that your Folk have filled in during the tournament
          will be taken to the final event: the Town Hall.
        </p>
        <button
          className={styles.choice}
          onClick={(event) => {
            setLiverNo(1);
          }}
        >
          go back!
        </button>
      </div>
    );
  }
  if (liverNo === 6) {
    return (
      <div className={styles.bkg}>
        <p>It’s a report written as if you were a non-human.</p>
        <p>
          You can leave an Incident Report by clicking on the game map. A form
          will pop up with questions to help you write your complaint.
        </p>
        <p>
          You earn points for your Folk by writing Incident Reports that are
          convincing, practical and that convince the top humans at FACT how
          much shit you're in.
        </p>
        <p>How do I make a BOSS Incident Report?</p>
        <p>
          Or for more answers,
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(1);
            }}
          >
            go back!
          </button>
        </p>
      </div>
    );
  }
  if (liverNo === 7) {
    return (
      <div className={styles.bkg}>
        <p>
          You’re never very far from one of them non-humans, so you can start by
          looking around and being curious about them.
        </p>
        <p>
          Imagine what their everyday lives are like. What does it feel like to
          be a daffodil, a sparrow or even the River Mersey? They might look and
          sound different to you, but they have their stuff going on.
        </p>
        <p>Some advice, love:</p>
        <p>
          -Spend a bit of time putting yourself in their
          hooves/paws/feet/pads/roots/sediment.
        </p>
        <p>
          -You can also have a look at some sample incident reports in the map
          that others have written in the past to help you.
        </p>
        <p>
          -The more you can imagine what it’s like to be a nonhuman, the better
          your Incident Report will be.
        </p>
        <p>
          Or for more answers,
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(1);
            }}
          >
            go back!
          </button>
        </p>
      </div>
    );
  }

  if (liverNo === 8) {
    return (
      <div className={styles.bkg}>
        <p>Typical selfish human.</p>
        <p>
          It’s not about you, IF your Folk wins you all share the power and the
          glory together.
        </p>
        <p>
          You can help your folk win by placing high scoring Incident Reports.
        </p>
        <p>
          I will moderate them reports and adjudicate them points if they're the
          good stuff...
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(9);
            }}
          >
            What do I win?
          </button>
        </p>
      </div>
    );
  }
  if (liverNo === 9) {
    return (
      <div className={styles.bkg}>
        <p>You're not getting anything, are you?</p>
        <p>
          The folk with the most points from both the game and the Town Hall
          will be crowned folk champions of Liverpool 2020 - they will have
          bragging rights over all the other non human folk in the city because
          we all know that they have the most influence over the boss humans at
          FACT.
        </p>
        <p>
          {" "}
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(1);
            }}
          >
            Oh. I guess that's fine.
          </button>
        </p>
      </div>
    );
  }
  if (liverNo === 10) {
    return (
      <div className={styles.bkg}>
        <p>
          Well you can filter them in the map by clicking and selecting your
          folk. If you entered a nickname, it should appear in the report.
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(1);
            }}
          >
            Go Back
          </button>
        </p>
      </div>
    );
  }
  if (liverNo === 11) {
    return (
      <div className={styles.bkg}>
        <p>
          Well, in your incident reports you can add links from articles or
          websites. Usually if you select an image online you should be able to
          ‘Copy Image Address’, then paste it in the report and that’s that.
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(1);
            }}
          >
            Go back
          </button>
        </p>
      </div>
    );
  }
  if (liverNo === 12) {
    return (
      <div className={styles.bkg}>
        <p>Whenever we’ve got a minute, love.</p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(1);
            }}
          >
            Go Back
          </button>{" "}
        </p>
      </div>
    );
  }

  if (liverNo === 13) {
    return (
      <div className={styles.bkg}>
        <p>
          The judges at the Town Hall will be top humans from FACT. They're
          gonna listen to one player from each folk present their most important
          problems and then award them points. The more they think they can do
          something about the problem, the higher points they will give, so
          you've gotta convince them!
        </p>
        <p>
          The Folk with the most points added together from this game and the
          Town Hall will be declared non human champions of FACT!
        </p>
        <p>
          Keep your eyes on the real prize though, the chance to influence the
          top humans at FACT to think of us when they write their new
          environmental policy, we just have to train them to think like us la!
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(1);
            }}
          >
            Go Back
          </button>{" "}
        </p>
      </div>
    );
  }
  if (liverNo === 14) {
    return (
      <div className={styles.bkg}>
        <p>
          Worry not lad, good ol' Liver Bird got you covered and won't tolerate
          profanity in this game.
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(1);
            }}
          >
            Go Back
          </button>{" "}
        </p>
      </div>
    );
  }
  if (liverNo === 15) {
    return (
      <div className={styles.bkg}>
        <p>
          Well don't look at me I'm just a metal bird on top of a building. But
          send a email to these peeps, it's probably their fault!
        </p>

        <p> learning@fact.co.uk</p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(1);
            }}
          >
            Go Back
          </button>{" "}
        </p>
      </div>
    );
  }
  if (liverNo === 16) {
    return (
      <div className={styles.bkg}>
        <p>
          <b>
            <u>INCIDENT MARKER SCORING CRITERIA</u>
          </b>
          <p>Each Incident Marker is awarded 0-50 points</p>
          <u>A Good Marker Typically:</u>
          <ul>
            <li className={styles.tips}>
              Gives a comprehensive description of the incident and enough
              details to paint a rich picture of the situation. (0-10 points)
            </li>
            <li className={styles.tips}>
              Provides things you have collected from the real world to support
              this, eg. photos, video and audio recordings. (0-10 points)
            </li>
            <li className={styles.tips}>
              Tells a personal story from your (nonhuman) point of view that
              allows us (humans) to empathise with you. (0-10 points)
            </li>
            <li className={styles.tips}>
              Shows you have thought about how your incident could have wider
              ecological or environmental consequences. (0-10 points)
            </li>
            <li className={styles.tips}>
              Provides a clear and practical idea of what you think humans
              (especially land owning and law making humans) should do to help
              you. (0-10 points)
            </li>
          </ul>
          <u>What makes a bad marker?</u>
          <ul>
            <li className={styles.tips}>
              If descriptions are too long (and not relevant) or too short (and
              not enough detail).
            </li>
            <li className={styles.tips}>
              If it isn't clear who is speaking and it is difficult to empathise
              with.
            </li>
            <li className={styles.tips}>
              If the text is badly written, e.g. lots of spelling mistakes, or
              if sentences don't make sense.{" "}
            </li>
            <li className={styles.tips}>
              if solutions are impractical, too expensive, or unrealistic.
            </li>
          </ul>
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(1);
            }}
          >
            Go Back
          </button>{" "}
        </p>
      </div>
    );
  }
  if (liverNo === 17) {
    return (
      <div className={styles.bkg}>
        <p>Quick Start Guide:</p>
        <p>-Pick a Folk by clicking on their GIF.</p>
        <p>-Observe the members of your folk around you.</p>
        <p>-Imagine their problems.</p>
        <p>-Become one of them.</p>
        <p>-Write a Report in the map.</p>
        <p>-Get points if you hit the criteria.</p>
        <p>-Your problem will be considered for the Environmental Policy.</p>
        <p>Clearer now love?</p>
        <p>Good.</p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setLiverNo(1);
            }}
          >
            Go Back
          </button>{" "}
        </p>
      </div>
    );
  }
}
export default LiverBird;
